module.exports = __webpack_public_path__ + "static/sideways_lrsystem-d252f80cea729cddf7f7d36f3a6d51ce.png";